/**
 * Nucery product rail: recommendations (JSON API) + recently viewed (theme-recent)
 */
(function () {
  'use strict';

  if (window.__nuceryProductRailJS) {
    return;
  }
  window.__nuceryProductRailJS = 1;

  var quickAddBound = false;

  function formatMoney(cents, moneyFormat) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var formatString = moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholder);
    if (!match) {
      return String(cents);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) {
        return '0';
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholder, value);
  }

  function escapeHtml(str) {
    if (str == null) {
      return '';
    }
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function featuredImageSrc(product) {
    var fi = product.featured_image;
    if (!fi) {
      if (product.images && product.images[0]) {
        var im = product.images[0];
        return typeof im === 'string' ? im : (im.src || im);
      }
      return '';
    }
    return typeof fi === 'string' ? fi : (fi.src || '');
  }

  function firstAvailableVariant(product) {
    if (!product.variants || !product.variants.length) {
      return null;
    }
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) {
        return product.variants[i];
      }
    }
    return product.variants[0];
  }

  function priceLabel(product, moneyFormat) {
    if (product.price_varies) {
      return 'From ' + formatMoney(product.price_min, moneyFormat);
    }
    return formatMoney(product.price, moneyFormat);
  }

  var BAG_SVG =
    '<svg class="nucery-product-rail__bag-svg" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 7h12l-1 12H7L6 7z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M9 7V5.5A2.5 2.5 0 0111.5 3h1A2.5 2.5 0 0115 5.5V7" stroke="currentColor" stroke-width="1.5"/></svg>';

  function buildCellHTML(product, opt) {
    var moneyFormat = opt.moneyFormat;
    var showQuick = opt.showQuickAdd;
    var img = featuredImageSrc(product);
    var title = escapeHtml(product.title);
    var v = firstAvailableVariant(product);
    var href = (product.url || '/products/' + product.handle).split('?')[0];
    var price = priceLabel(product, moneyFormat);
    var quick = '';
    if (showQuick && v) {
      var disabled = v.available ? '' : ' disabled';
      quick =
        '<button type="button" class="nucery-product-rail__quick-add" data-nucery-quick-add data-variant-id="' +
        v.id +
        '" data-variant-count="' +
        ((product.variants && product.variants.length) || 1) +
        '" data-product-handle="' +
        escapeHtml(product.handle || '') +
        '" data-product-title="' +
        title +
        '"' +
        disabled +
        ' aria-label="Add to cart: ' +
        title +
        '"><span class="nucery-product-rail__quick-add-inner" aria-hidden="true">' +
        BAG_SVG +
        '</span></button>';
    }
    var imgBlock = img
      ? '<img class="nucery-product-rail__image" src="' +
        escapeHtml(img) +
        '" alt="' +
        title +
        '" loading="lazy" width="900" height="900" />'
      : '<div class="nucery-product-rail__placeholder"></div>';
    return (
      '<div class="nucery-product-rail__cell">' +
      '<article class="nucery-product-rail__card" data-product-id="' +
      product.id +
      '">' +
      '<div class="nucery-product-rail__image-wrap">' +
      '<a href="' +
      escapeHtml(href) +
      '" class="nucery-product-rail__image-link" tabindex="-1" aria-hidden="true">' +
      imgBlock +
      '</a>' +
      quick +
      '</div>' +
      '<a href="' +
      escapeHtml(href) +
      '" class="nucery-product-rail__meta">' +
      '<h3 class="nucery-product-rail__title">' +
      title +
      '</h3>' +
      '<p class="nucery-product-rail__price">' +
      price +
      '</p>' +
      '</a></article></div>'
    );
  }

  var flickityByRoot = new WeakMap();

  function destroyFlickity(root) {
    var flkty = flickityByRoot.get(root);
    if (flkty && typeof flkty.destroy === 'function') {
      flkty.destroy();
    }
    flickityByRoot.delete(root);
  }

  function visibleCellCount(root) {
    var perRow = parseInt(root.getAttribute('data-products-per-row') || '4', 10);
    if (window.matchMedia('(max-width: 768px)').matches) {
      return 1;
    }
    return Math.max(1, perRow);
  }

  function railIsScrollable(root, flkty) {
    if (!flkty || !flkty.cells || !flkty.cells.length) {
      return false;
    }
    return flkty.cells.length > visibleCellCount(root);
  }

  function updateRailNav(root, flkty) {
    var carousel = root.querySelector('[data-rail-carousel]');
    if (!carousel || !flkty) {
      return;
    }
    var scrollable = railIsScrollable(root, flkty);
    carousel.classList.toggle('is-scrollable', scrollable);

    var prev = carousel.querySelector('[data-rail-prev]');
    var next = carousel.querySelector('[data-rail-next]');
    if (!prev || !next) {
      return;
    }

    if (!scrollable) {
      prev.disabled = true;
      next.disabled = true;
      return;
    }

    prev.disabled = flkty.selectedIndex <= 0;
    next.disabled = flkty.selectedIndex >= flkty.slides.length - 1;
  }

  function bindRailNav(root, flkty) {
    var carousel = root.querySelector('[data-rail-carousel]');
    if (!carousel) {
      return;
    }

    if (root.getAttribute('data-rail-nav-ready') !== '1') {
      root.setAttribute('data-rail-nav-ready', '1');
      var prev = carousel.querySelector('[data-rail-prev]');
      var next = carousel.querySelector('[data-rail-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          var active = flickityByRoot.get(root);
          if (active) {
            active.previous();
          }
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          var active = flickityByRoot.get(root);
          if (active) {
            active.next();
          }
        });
      }
    }

    flkty.on('select', function () {
      updateRailNav(root, flkty);
    });
    flkty.on('resize', function () {
      updateRailNav(root, flkty);
    });

    updateRailNav(root, flkty);
  }

  function initFlickity(root) {
    if (typeof Flickity === 'undefined') {
      return;
    }
    var slider = root.querySelector('.nucery-product-rail__slider');
    if (!slider) {
      return;
    }
    var n = root.querySelectorAll('.nucery-product-rail__cell').length;
    if (n < 1) {
      return;
    }
    destroyFlickity(root);
    var isSmall = window.matchMedia('(max-width: 768px)').matches;
    var perRow = parseInt(root.getAttribute('data-products-per-row') || '4', 10);
    var groupCells = false;
    if (!isSmall && n > perRow) {
      groupCells = perRow;
    }

    var flkty = new Flickity(slider, {
      cellSelector: '.nucery-product-rail__cell',
      wrapAround: false,
      pageDots: false,
      contain: true,
      groupCells: groupCells,
      prevNextButtons: false,
      cellAlign: 'left',
      draggable: true,
      selectedAttraction: 0.045,
      friction: 0.32,
    });
    flickityByRoot.set(root, flkty);
    bindRailNav(root, flkty);
  }

  function readMoneyFormatFromDom(root) {
    var s = root.getAttribute('data-money-format');
    if (!s) {
      return '';
    }
    if (s.charAt(0) === '"' && s.charAt(s.length - 1) === '"') {
      try {
        return JSON.parse(s);
      } catch (e) {
        return s.slice(1, -1);
      }
    }
    return s;
  }

  function bindQuickAddOnce() {
    if (quickAddBound) {
      return;
    }
    quickAddBound = true;
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest && e.target.closest('.nucery-product-rail__quick-add');
        if (!btn || !btn.hasAttribute('data-nucery-quick-add')) {
          return;
        }
        /* Ignore stray hits / mis-stacked UI: only real product merchandising zones. */
        var host =
          btn.closest(
            '.nucery-product-grid, .nucery-product-rail, .bestsellers-tabbed__grid, .nucery-search__products, .nucery-search__products-static, .ncs-grid'
          );
        if (!host) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) {
          return;
        }
        var id = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!id) {
          return;
        }
        btn.setAttribute('aria-busy', 'true');
        var formData = new FormData();
        formData.append('id', String(id));
        formData.append('quantity', '1');
        // Locale/market-aware: Shopify Markets prefixes routes (e.g. /en-sa/), so a bare /cart/add.js 404s.
        var addUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';
        if (window.theme && window.theme.routes && window.theme.routes.cartAdd) {
          addUrl = window.theme.routes.cartAdd;
        }
        fetch(addUrl, {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (data && data.status === 422) {
              document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            } else {
              document.dispatchEvent(
                new CustomEvent('ajaxProduct:added', {
                  bubbles: true,
                  detail: { product: data, addToCartBtn: btn },
                })
              );
            }
          })
          .catch(function () {
            var link = btn.closest('article.nucery-product-rail__card') &&
              btn
                .closest('article.nucery-product-rail__card')
                .querySelector('a.nucery-product-rail__meta[href]');
            if (link) {
              window.location.href = link.getAttribute('href');
            }
          })
          .finally(function () {
            btn.removeAttribute('aria-busy');
          });
      },
      true
    );
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(
      function (r) {
        if (!r.ok) {
          throw new Error('HTTP ' + r.status);
        }
        return r.json();
      }
    );
  }

  function getRecentHandles() {
    var raw;
    try {
      raw = window.localStorage.getItem('theme-recent');
    } catch (err) {
      return [];
    }
    if (!raw) {
      return [];
    }
    var o;
    try {
      o = JSON.parse(raw);
    } catch (e) {
      return [];
    }
    if (!o || typeof o !== 'object') {
      return [];
    }
    return Object.keys(o).filter(function (h) {
      return h && h !== 'undefined';
    });
  }

  function runRecommendations(root) {
    var pid = root.getAttribute('data-product-id');
    if (!pid) {
      return Promise.resolve();
    }
    var limit = parseInt(root.getAttribute('data-limit') || '8', 10);
    var u =
      '/recommendations/products.json?product_id=' +
      encodeURIComponent(pid) +
      '&limit=' +
      encodeURIComponent(String(limit)) +
      '&intent=related';
    return fetchJson(u)
      .then(function (data) {
        return (data && data.products) || [];
      })
      .then(function (products) {
        renderFromProducts(root, products);
      });
  }

  function runRecentlyViewed(root) {
    var current = root.getAttribute('data-current-handle') || '';
    var limit = parseInt(root.getAttribute('data-limit') || '8', 10);
    var handles = getRecentHandles().filter(function (h) {
      return h !== current;
    });
    handles = handles.slice().reverse();
    if (handles.length > limit) {
      handles = handles.slice(0, limit);
    }
    if (handles.length === 0) {
      root.classList.add('nucery-product-rail--hidden', 'nucery-product-rail--empty');
      return Promise.resolve();
    }
    return Promise.all(
      handles.map(function (h) {
        return fetchJson('/products/' + encodeURIComponent(h) + '.js');
      })
    )
      .then(function (list) {
        return list.filter(function (p) {
          return p && p.handle && p.handle !== current;
        });
      })
      .then(function (products) {
        renderFromProducts(root, products);
      })
      .catch(function () {
        root.classList.add('nucery-product-rail--hidden', 'nucery-product-rail--empty');
      });
  }

  function renderFromProducts(root, products) {
    var track = root.querySelector('[data-rail-cells]');
    if (!track) {
      return;
    }
    var showQuick = root.getAttribute('data-show-quick') === 'true' || root.getAttribute('data-show-quick') === '1';
    var moneyFormat = readMoneyFormatFromDom(root);
    var opt = { moneyFormat: moneyFormat, showQuickAdd: showQuick };

    if (!products || !products.length) {
      if (track.querySelector && !track.querySelector('.nucery-product-rail__cell')) {
        root.classList.add('nucery-product-rail--hidden', 'nucery-product-rail--empty');
      }
      return;
    }

    destroyFlickity(root);
    track.innerHTML = products.map(function (p) {
      return buildCellHTML(p, opt);
    }).join('');

    root.classList.remove('nucery-product-rail--hidden', 'nucery-product-rail--empty', 'nucery-product-rail--loading');
    var skel = root.querySelector('.nucery-product-rail__skeleton');
    if (skel) {
      skel.setAttribute('hidden', '');
    }

    requestAnimationFrame(function () {
      initFlickity(root);
      if (root._nuceryResize) {
        window.removeEventListener('resize', root._nuceryResize);
      }
      var resizeT;
      root._nuceryResize = function () {
        clearTimeout(resizeT);
        resizeT = setTimeout(function () {
          initFlickity(root);
        }, 180);
      };
      window.addEventListener('resize', root._nuceryResize, { passive: true });
    });
  }

  function initRoot(root) {
    if (root.getAttribute('data-initialized') === '1') {
      return;
    }
    root.setAttribute('data-initialized', '1');
    bindQuickAddOnce();

    if (root.querySelectorAll('.nucery-product-rail__cell').length > 0) {
      var skel = root.querySelector('.nucery-product-rail__skeleton');
      if (skel) {
        skel.setAttribute('hidden', '');
      }
      requestAnimationFrame(function () {
        initFlickity(root);
        var resizeT;
        if (root._nuceryResize) {
          window.removeEventListener('resize', root._nuceryResize);
        }
        root._nuceryResize = function () {
          clearTimeout(resizeT);
          resizeT = setTimeout(function () {
            initFlickity(root);
          }, 180);
        };
        window.addEventListener('resize', root._nuceryResize, { passive: true });
      });
      return;
    }

    var mode = root.getAttribute('data-mode');
    if (mode === 'recommendations') {
      return runRecommendations(root).then(function () {
        if (!root.querySelector || !root.querySelector('.nucery-product-rail__cell')) {
          root.classList.add('nucery-product-rail--hidden', 'nucery-product-rail--empty');
        }
      });
    }
    if (mode === 'recently_viewed') {
      return runRecentlyViewed(root);
    }
  }

  function boot() {
    // Bind global quick-add delegate even when no rail is on the page
    // (used by .grid-product__bag on the collection page).
    bindQuickAddOnce();
    document.querySelectorAll('.nucery-product-rail[data-rail]').forEach(function (r) {
      var defer = parseInt(r.getAttribute('data-defer-millis') || '0', 10) || 0;
      if (r.getAttribute('data-mode') === 'recently_viewed') {
        defer = Math.max(defer, 200);
      }
      if (defer) {
        setTimeout(function () {
          initRoot(r);
        }, defer);
      } else {
        initRoot(r);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
